import installZotero from './zotero';

export default function install(config) {
  return installZotero(config);
}
